<template>
    <div class="justify-content-between align-items-center alphabet d-none d-xl-flex">
        <div v-for="letter, key in alphabet" :key="key" class="letters">
            <template v-if="usedLetters.includes(letter)">
                <button type="button"
                        class="letter uppercase btn px-3"
                        :class="selectedLetter == letter ? 'active'  : ''"
                        @click="selectTown(letter)">
                    {{ letter }}
                </button>
            </template>
            <template v-else>
                <button type="button" class="uppercase btn btn-dark px-3" disabled>
                    {{ letter }}
                </button>
            </template>
        </div>
    </div>

    <div class="form-group d-block d-xl-none">
        <select class="form-select text-uppercase" :value="selectedLetter" @change="selectTown($event.target.value)">
            <option v-for="(letter, key) of alphabet" :value="letter" :disabled="!usedLetters.includes(letter)">
                {{ letter }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: ["usedLetters", "currentRoute", "defaultLetter"],
    data() {
        return {
            alphabet: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"],
            selectedLetter: this.defaultLetter
        };
    },
    mounted() {
    },
    methods: {
        selectTown(letter) {
            this.selectedLetter = letter;
            this.emitter.emit("selectTown", letter);
        }
    },
    computed: {}
};
</script>

<style lang="scss" scoped>
.alphabet {
    .letters {
        .letter {
            background-color: #f8f9fa;

            &.active {
                background-color: #0064EF;
                color: #fff;
            }
        }
    }
}
</style>